import Loading from '@dtvgo/loading';
import BigPlayButton from '../BigPlayButton/BigPlayButton.js';
import './PlayerOverlay.scss';
import { jsxs, jsx } from 'react/jsx-runtime';
import '@dtvgo/icon';
import '../PlayerButton/PlayerButton.js';
import '../PlayerButton/PlayerButton.scss';
import '../BigPlayButton/BigPlayButton.scss';

/* External */

function PlayerOverlay(_ref) {
  var isUserActive = _ref.isUserActive,
    showIconPlayButton = _ref.showIconPlayButton,
    handleTogglePlayPause = _ref.handleTogglePlayPause,
    handleToggleFullScreen = _ref.handleToggleFullScreen,
    isBuffering = _ref.isBuffering,
    tooltip = _ref.tooltip;
  return /*#__PURE__*/jsxs("div", {
    className: "dtv-common-c-player-overlay ".concat(isBuffering ? 'dtv-common-c-player-overlay--buffering' : ''),
    style: {
      cursor: !isUserActive ? 'none' : ''
    },
    onClick: handleTogglePlayPause,
    onKeyPress: function onKeyPress() {},
    onDoubleClick: handleToggleFullScreen,
    role: "presentation",
    children: [!isBuffering && showIconPlayButton && /*#__PURE__*/jsx(BigPlayButton, {
      tooltip: tooltip
    }), isBuffering && /*#__PURE__*/jsx(Loading, {})]
  });
}
PlayerOverlay.defaultProps = {
  isUserActive: false,
  isBuffering: false,
  showIconPlayButton: false,
  handleToggleFullScreen: function handleToggleFullScreen() {},
  handleTogglePlayPause: function handleTogglePlayPause() {},
  tooltip: ''
};

export { PlayerOverlay as default };
//# sourceMappingURL=PlayerOverlay.js.map
